import React from 'react';
import { Search } from '@parrot-software/design-system/icons';

/**
 * Props for EmptyState component
 */
export interface EmptyStateProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
}

/**
 * EmptyState - Generic empty state component for subscription sections.
 *
 * Displays a centered icon, title, and description when no data is available.
 * Reusable across payment history, invoice data, and other subscription tabs.
 */
export const EmptyState = ({ title, description, icon }: EmptyStateProps) => (
  <div className="flex flex-col h-[50vh] items-center justify-center gap-4 rounded-xl border p-12 shadow-xs">
    {icon ?? <Search className="h-9 w-9 text-primary" strokeWidth={1.5} />}
    <div className="text-center">
      <p className="mb-1 text-lg font-medium">{title}</p>
      <p className="text-sm text-muted-foreground">{description}</p>
    </div>
  </div>
);
